export const processLocation = (locationName) => {
  const parts = locationName.split("/content/")[1]?.split("/")[0];
  return parts || null;
};

export const extractPath = (url) => {
  // Remove protocol and domain to get the path
  const path = new URL(url).pathname;
  // Split the path into segments
  const segments = path.split("/").filter((segment) => segment !== "");
  // Extract segments from the second to the second last
  const extractedPath = segments.slice(1, -1).join("/");
  return extractedPath;
};
